import axios from "axios"
import { Button } from "primereact/button"
import { Chip } from "primereact/chip"
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { InputText } from "primereact/inputtext"
import { Toast } from "primereact/toast"
import { Fragment, useEffect, useRef, useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { enumHttpError } from "../../enums/enumHttpError"
import EnvironnementDeTravailService from "../../services/environnementDeTravailService"
export const PickListEnvironnementDeTravail = (props) => {

    const { t } = useTranslation();

    const toast = useRef(null);
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    let cancel;

    const [globalFilter, setGlobalFilter] = useState(null);
    const [environnementDeTravails, setEnvironnementDeTravails] = useState(null);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [filterTimerId, setFilterTimerId] = useState(null)

    const environnementDeTravailService = new EnvironnementDeTravailService();

    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: 'libelle',
        sortOrder: 1
    });

    useEffect(() => {
        setLoading(true);
        if (cancel) {
            source.cancel();
        }
        cancel = source.token;
        environnementDeTravailService.getStructuresPaginated(lazyParams, { cancelToken: cancel })
            .then(data => {
                setTotalRecords(data.totalCount);
                setEnvironnementDeTravails(data.items);
                setLoading(false);
            })
            .catch(err => {
                if (err.message != enumHttpError.CANCELED) {
                    showError();
                    setLoading(false);
                }
            })
        return () => source.cancel();
    }, [lazyParams])

    const showError = () => {
        toast.current.show({ severity: 'error', summary: t('general.failed'), detail: t('general.loading_failed'), life: 3000 });
    }

    const onPage = (event) => {
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    }

    const onFilter = (event) => {
        if (filterTimerId) {
            clearTimeout(filterTimerId);
        }
        var _filterTimerId = setTimeout(() => {
            let _lazyParams = { ...lazyParams, ...event };
            _lazyParams['page'] = 0;
            _lazyParams['first'] = 0;
            setLazyParams(_lazyParams);
            setFilterTimerId(null);
        }, 1000)
        setFilterTimerId(_filterTimerId);
    }

    const classeObjetDejaAjoute = "p-button-rounded p-button-secondary align-right";
    const classeObjetPourAjouter = "p-button-rounded p-button-info align-right";

    const pickListActionBodyTemplate = (rowData) => {
        const bDejaAjoute = props.list?.filter(o => o.id === rowData.id).length > 0;
        return (
            <Button icon="pi pi-arrow-right" className={bDejaAjoute ? classeObjetDejaAjoute : classeObjetPourAjouter} onClick={() => props.onAdd(rowData, 0)} />
        );
    }
    const searchbar = (
        <div>
            {t('structures.structures')}
            <span className="p-input-icon-left responsive">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder={t('general.search')} />
            </span>
        </div>
    )

    return (
        <>
            <Toast ref={toast} />
            <div className="p-grid">
                <div className="p-col">
                    <DataTable value={environnementDeTravails}
                        lazy
                        filterDelay={1000}
                        emptyMessage={t('structures.empty')}
                        dataKey="id"
                        globalFilter={globalFilter}
                        paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[5, 10, 25]}
                        totalRecords={totalRecords}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate={t('structures.footer_count_pagin')}
                        onPage={onPage}
                        onFilter={onFilter}
                        loading={loading}
                    >
                        <Column field="libelle" header={searchbar} headerStyle={{ width: '15rem' }} sortable></Column>
                        <Column headerStyle={{ width: '1rem' }} body={pickListActionBodyTemplate}></Column>
                    </DataTable>
                </div>
                <div className="p-col">
                    <div>
                        <h2><Trans i18nKey="formation.target_structures" /></h2>
                        {props.list?.map((struct, indexStruct) => (
                            <Fragment key={`${struct}~${indexStruct}`}>
                                <Chip label={<div style={{ display: "inline-flex" }} ><span style={{ alignSelf: 'center' }}>{struct.libelle}</span><Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-text" onClick={e => props.onRemove(e, struct.id)} /></div>} className="p-field" ></Chip>
                            </Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}